import { connect } from 'react-redux'
import OnboardStart from './components/Onboard/OnboardStart'

const mapDispatchToProps = dispatch => ({
    dispatch
})

export default connect((state) => ({ onboard: state.onboard }), mapDispatchToProps)(OnboardStart)
